import React, { FC } from 'react';

import { MoneyFlowChartContainer } from 'containers';

export const ChartScreen: FC = () => {
  return <MoneyFlowChartContainer />;
};
